import { Offer } from "src/types/Offer";

export const isFixtureOfferId = (offerId: Offer["id"]): boolean =>
  offerId.startsWith("fixture_off_");
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";